var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{class:_vm.approachingDeadline(_vm.date) ? _vm.approachingClass : ''},[_vm._v(_vm._s(_vm._f("humanizeDateTime")(_vm.date)))]),_c('div',{class:_vm.dateClass},[_vm._v(_vm._s(_vm._f("dateTimeFilter")(_vm.date)))]),(!_vm.date)?_c('div',{class:_vm.emptyClass},[_vm._v(_vm._s(_vm.emptyText))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }